import type {
  getClaimsQuery,
  providerClaimQuery,
} from "../../remote/gql/graphql";
import type { BatchClaimsResult } from "../../remote/queries/batchClaims.gql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { batchClaimsQueryDoc } from "../../remote/queries/batchClaims.gql";
import { getClaimsQueryDoc } from "../../remote/queries/getClaims.gql";
import { getProviderClaimQueryDoc } from "../../remote/queries/getProviderClaim.gql";
import { AlaffiaClientModule } from "./modules";

type ClaimsModuleArgs = AlaffiaClientModuleArgs;

export class ClaimsModule extends AlaffiaClientModule {
  constructor(args: ClaimsModuleArgs) {
    super(args);
  }

  getProviderClaim = async (input: {
    id: string;
  }): ClientReturnType<providerClaimQuery["claim"]> => {
    const result = await this.runGqlQuery(
      getProviderClaimQueryDoc,
      { id: input.id },
      "getProviderClaim",
    );

    return {
      data: result.data?.claim ?? null,
      error: result.error ?? null,
    };
  };

  getAllClaims = async (): ClientReturnType<getClaimsQuery["claims"]> => {
    const result = await this.runGqlQuery(
      getClaimsQueryDoc,
      {},
      "getAllClaims",
    );

    return {
      data: result.data?.claims ?? null,
      error: result.error ?? null,
    };
  };

  batchClaims = async (input: {
    includes: string;
    userBasedFilter: Record<string, unknown>;
  }): ClientReturnType<BatchClaimsResult["batchClaims"]> => {
    const result = await this.runGqlQuery(
      batchClaimsQueryDoc,
      {
        includes: input.includes,
        userBasedFilter: input.userBasedFilter,
      },
      "batchClaims",
    );

    return {
      data: result.data?.batchClaims ?? null,
      error: result.error ?? null,
    };
  };
}
